import React, { memo } from 'react';
import { CloseIcon } from '../Icons';

export interface CarouselHeaderProps {
  currentIndex: number;
  totalCount: number;
  onClose: () => void;
}

function CarouselHeaderComponent({
  currentIndex,
  totalCount,
  onClose
}: CarouselHeaderProps): React.ReactElement {
  return (
    <header className="attachment-carousel__header">
      <span className="attachment-carousel__counter">
        {currentIndex + 1} of {totalCount}
      </span>
      <button
        type="button"
        className="attachment-carousel__close"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon />
      </button>
    </header>
  );
}

export const CarouselHeader = memo(CarouselHeaderComponent);
CarouselHeader.displayName = 'CarouselHeader';
